<body [style.margin-left.px]="userRole === 1 ? 0 : 250">
<div class="ticket-details-container" *ngIf="ticket">
    <div class="ticket-header">
        <h2>Tickets Details</h2>

      <div class="status-actions">
        <ng-container *ngIf="ticket?.status === 1
        && !(userRole === 0 || (userRole === 3 && creatorUserAccesType === 0)) 
        && !(userRole === 1 || (userRole === 3 && creatorUserAccesType === 1)) && !(ticket?.category === 3) ">
          <button pButton class="status-btn in-progress" (click)="openModal('inProgress')">In Progress</button>
        </ng-container>
      </div>
      <div class="status-actions" *ngIf="ticket?.status === 1 && ticket?.category === 3 
          && (userRole === 0 || (userRole === 3 && creatorUserAccesType === 0))">
        <ng-container>
          <button pButton class="status-btn in-progress" (click)="openModal('inProgress')">In Progress</button>
        </ng-container>
      </div>
      <div class="status-actions" *ngIf="ticket?.status === 5 ">
        <ng-container>
          <button pButton class="btn-primary" (click)="openModal('resolved')">Resolved</button>
          <!-- <button pButton class="status-btn closed" (click)="openModal('closed')">Closed</button> -->
        </ng-container>
      </div>
      <div class="status-actions" *ngIf="ticket?.status === 3 && !(userRole === 1 || (userRole === 3 && creatorUserAccesType === 1)) && !(ticket?.category === 3 && (userRole === 4 || (userRole === 3 && creatorUserAccesType === 4)))">
        <ng-container>
          <button pButton class="status-btn closed" (click)="openModal('closed')">Closed</button>
        </ng-container>
      </div>
      <div class="status-actions" *ngIf="ticket?.status === 2 && !(userRole === 1 || (userRole === 3 && creatorUserAccesType === 1)) && !(ticket?.category === 3 && (userRole === 4 || (userRole === 3 && creatorUserAccesType === 4)))" >
        <ng-container>
          <button pButton class="btn-primary" (click)="openModal('resolved')">Resolved</button>
          <!-- <button pButton class="status-btn closed" (click)="openModal('closed')">Closed</button> -->
        </ng-container>
      </div>
    </div>

    <div class="ticket-body ticket-card">
      <div class="ticket-header">
        <h3>{{ ticket?.title }} 
          <span *ngIf="ticket?.ticketNumber">
            (#{{ ticket?.ticketNumber }})
          </span>
        </h3>
        <!-- <span class="status-badge open">{{ getStatusText(ticket?.status) }}</span> -->
         <span class="tag" [ngClass]="{
            open: getStatusText(ticket.status) === 'Open',
            inProgress: getStatusText(ticket.status) === 'In Progress',
            resolved: getStatusText(ticket.status) === 'Resolved',
            closed: getStatusText(ticket.status) === 'Closed',
            escalated: getStatusText(ticket.status) === 'Escalated'
          }">{{ getStatusText(ticket.status) }}</span>
      </div>
      <div class="border mb-2"></div>
      <div class="property-row">
        <p class="label"><strong>Created :</strong></p>
        <p class="value">{{ ticket?.createdOn | date }}</p>
      </div>

      <div class="property-row">
        <p class="label"><strong>Last Updated :</strong></p>
        <p class="value">{{ ticket?.createdOn | date }}</p>
      </div>

      <div class="property-row">
        <p class="label"><strong>Submitted Time :</strong></p>
        <p class="value">{{ ticket?.createdOn | date:'shortTime' }}</p>
      </div>

      <div class="property-row">
        <p class="label"><strong>Description :</strong></p>
        <p class="value">{{ ticket?.description }}</p>
      </div>

      <div class="property-row">
        <p class="label"><strong>Category :</strong></p>
        <p class="value">{{ getCategoryText(ticket?.category) }}</p>
      </div>

      <div class="property-row">
        <p class="label"><strong>Preferred Contact Mode :</strong></p>
        <p class="value">{{ getContactModeText(ticket?.preferredContactMode) }}</p>
      </div>

      <div class="property-row" *ngIf="ticket?.category !== 3">
        <p class="label"><strong>Related Service Provider :</strong></p>
        <p class="value">{{ ticket?.serviceProvider?.name }}</p>
      </div>
    </div>

     <div class="ticket-body ticket-card">
      <p class="attach"><strong>Attachments :</strong></p>
      <div class="attachments" *ngFor="let file of ticket.attachments">
        <button class="file-btn" (click)="showPreview(file)">
          <i class="pi pi-file"></i> {{ file.fileName }}
        </button>
        <button class="download-btn" (click)="downloadFile(file)">
        <i class="pi pi-download"></i>
      </button>
      </div>
    </div>

    <div class="ticket-body ticket-card">
      <p class="attach"><strong>History :</strong></p>
      <p-timeline
        [value]="ticket?.history"
        layout="horizontal"
        align="alternate"
        styleClass="custom-timeline"
      >
        <ng-template pTemplate="marker" let-item>
          <span
            class="custom-marker"
            [ngClass]="{ 'completed': item.isCompleted }"
          ></span>
        </ng-template>

        <ng-template pTemplate="content" let-item>
          <div class="status">{{ item.status }}</div>
          <div class="created-by">
           {{ item.createdBy?.name }}
          </div>
          <div class="date">{{ item.dateTime  | date: 'MMM d, yyyy, h:mm a' }}</div>
        </ng-template>
      </p-timeline>

    </div>


  <div class="comments-section">
    <h4>Discussion</h4>

    <div class="comments-list">
      <div *ngIf="comments.length === 0" class="no-comments">No comments yet.</div>
      <div *ngFor="let c of comments" class="comment">
      <div class="avatar">{{ c.author[0] }}</div>
      <div class="comment-content">
        <div class="comment-header">
          <span class="name">{{ c.author }}</span>
          <span class="time">{{ c.createdAt | date:'short' }}</span>
        </div>
        <p>{{ c.text }}</p>
        <div *ngIf="c.attachment" class="comment-attachment">
          <i class="pi pi-paperclip"></i>
          <a [href]="c.attachmentUrl" target="_blank">{{ c.attachment }}</a>

          <div *ngIf="isImage(c.attachment)" class="preview">
            <img [src]="c.attachmentUrl" alt="Image Preview" class="preview-image" />
          </div>

          <!-- <div *ngIf="isPDF(c.attachment)" class="preview">
            <iframe [src]="c.attachmentUrl" class="preview-pdf"></iframe>
          </div> -->

        </div>

       </div>
    </div>
    </div>
    

    <!-- <div class="add-comment">
      <div class="input-wrapper">
        <input [(ngModel)]="newComment" placeholder="Add a comment..." (keydown.enter)="submitComment()" />
        
        <i class="pi pi-paperclip upload-icon" (click)="fileInput.click()"></i>
        <input #fileInput type="file" (change)="onFileSelected($event)" style="display: none;" />
      </div>
      <button class="submit-btn btn-primary" (click)="submitComment()">Submit</button>
    </div> -->

<div class="chat-input-container">
  <div class="input-area">
    <div *ngIf="selectedFile" class="file-preview-inside">
      <span>{{ selectedFile.name }}</span>
      <span class="remove-file" (click)="removeSelectedFile()"><i class="pi pi-times" style="font-size: 0.7rem"></i></span>
    </div>

    <textarea
      rows="1"
      [(ngModel)]="newComment"
      (input)="autoGrow($event)"
      (keydown.enter)="submitComment()"
      placeholder="Add a comment..."
    ></textarea>

    <!-- Icons inside input -->
    <div class="input-icons">
      <i class="pi pi-paperclip" (click)="fileInput.click()"></i>
      <input #fileInput type="file" hidden (change)="onFileSelected($event)" />
      <i class="pi pi-send" (click)="submitComment()"></i>
    </div>
  </div>
  
</div>


  </div>
</div>
</body>

<div *ngIf="previewVisible" class="preview-modal">
  <div class="modal-content">
    <span class="close-btn" (click)="closePreview()">&times;</span>
    
    <div *ngIf="isImage(previewFileName!)">
      <img [src]="previewUrl" width="700px" height="550px" alt="Attachment Preview" />
    </div>
    <div *ngIf="isPDF(previewFileName!)">
      <iframe [src]="previewUrl" width="100%" height="600px"></iframe>
    </div>
  </div>
</div>


<div *ngIf="activeModal === 'resolved'" class="preview-modal">
   <div class="modalcontent">
        <span class="close-btn" (click)="closeModal()">&times;</span>
        <h3>Mark as Resolved</h3>
        <p>Are you sure you want to mark this ticket as <strong>Resolved</strong>?</p>
      <div class="modal-actions">
        <button class="btn-primary" (click)="changeStatus(3)">Confirm</button>
        <button class="btn btn-cancel" (click)="closeModal()">Cancel</button>
      </div>
    </div>
</div>

<div *ngIf="activeModal === 'inProgress'" class="preview-modal">
  <div class="modalcontent">
    <span class="close-btn" (click)="closeModal()">&times;</span>
    <h3>Mark as In Progress</h3>
    <p>Are you sure you want to mark this ticket as <strong>In Progress</strong>?</p>
    <div class="modal-actions">
      <button class="btn-primary" (click)="changeStatus(2)">Confirm</button>
      <button class="btn btn-cancel" (click)="closeModal()">Cancel</button>
    </div>
  </div>
</div>

<div *ngIf="activeModal === 'closed'" class="preview-modal">
  <div class="modalcontent">
    <span class="close-btn" (click)="closeModal()">&times;</span>
    <h3>Mark as Closed</h3>
    <p>Are you sure you want to mark this ticket as <strong>Closed</strong>?</p>
    <div class="modal-actions">
      <button class="btn-primary" (click)="changeStatus(4)">Confirm</button>
      <button class="btn btn-cancel" (click)="closeModal()">Cancel</button>
    </div>
  </div>
</div>
